// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"23":"b81475f5","34":"e2d15a2c","117":"881fb372","122":"09cc50f3","162":"d42f7ee9","297":"2dbabc96","354":"4ecafc31","359":"53bb870f","420":"b95b3845","663":"127fdd09","742":"2d17e69f","760":"5b56f2ad","828":"44e7f20c","883":"6761dc23"}[chunkId] + ".chunk.css";
};